function initGrid() {
    $('.b-grid').each(function(){
        if (!this.initialized) {
            this.initialized = true;
            var $grid = $(this);
            if($grid.is('.b-tab-parent__tab')) {
                $grid.addClass('is-loading');
                $grid.isotope({
                    itemSelector: '.b-grid-card',
                    layoutMode: 'packery'
                })
                $grid.on('arrangeComplete', $grid.removeClass('is-loading') );
                $(document).on('classGiven', function(){
                    $grid.isotope('layout');
                })
            } else {
                $grid.isotope({
                    itemSelector: '.b-grid-card',
                    layoutMode: 'packery'
                })
            }
        }
    })
}
$(function(){
    initGrid();
});
